<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-row class="mt-5 ml-5">
			<v-col cols="12" class="d-flex">
				<div style="width: 200px;">
					<v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value"
						label="年份" dense outlined></v-select>
				</div>
				<v-btn class="ml-2" color="info" @click="getEduCameClassChartData">查询</v-btn>
			</v-col>
		</v-row>
		<div class="ml-5 mr-5 mt-5">
			<ve-histogram ref="chart1" :data="chartData1" height="600px" :extend="chartExtend1" ></ve-histogram>
		</div>
	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "edu-dashboard-index",
		data() {
			this.chartExtend1 = {
			  title: {
				text: '学员应到/实到统计'
			  },
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/home/index"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '教务数据报表',
						disabled: true
					},
				],
				tab:null,
				shopId:"",
				yearItems:[],
				query: {
					year:""+new Date().getFullYear()
				},
				chartData1: {
					columns: ['月份', '应到人数','实到人数'],
					rows: [],
				},
				
				
			}
		},
		mounted() {
			this.generateYearItems();
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getEduCameClassChartData();
		},
		methods: {
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			getEduCameClassChartData() {
			
				const that = this;
			
				let url = `/report/edu/came/class/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
				
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]);
						
						that.chartData1.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
						that.chartData1.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						that.summaryText  =  response.data["data"]["summaryText"];
						
						return
					}
			
				})
			},
		}
	}
</script>

<style>
</style>
